import { taskAdminApis } from '@gleamer/apis';
import { useQuery } from '@tanstack/react-query';
import { useAuthorization } from './useImports';

const { fetchAdminTaskDetails, fetchAdminTasks } = taskAdminApis;

export const ADMIN_TASKS_KEY = 'admin-tasks';

/** Every task, read once and kept a minute: the page works on it in the browser. */
export function useAdminTasks() {
  const auth = useAuthorization();
  return useQuery({
    queryKey: [ADMIN_TASKS_KEY],
    queryFn: () => fetchAdminTasks(auth),
    staleTime: 60_000,
  });
}

/** One task's details, read when it is opened. */
export function useAdminTaskDetails(taskId: number | null) {
  const auth = useAuthorization();
  return useQuery({
    queryKey: [ADMIN_TASKS_KEY, taskId, 'details'],
    queryFn: () => fetchAdminTaskDetails(auth, taskId as number),
    enabled: taskId !== null,
    staleTime: 60_000,
  });
}
